module.exports = __webpack_public_path__ + "b02bdc1b846fd65473922f5f62832108.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.9@element-ui/lib/theme-default/fonts/element-icons.ttf?t=1472440741
// module id = 34
// module chunks = 8